var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modalOverlay"}),_c('div',{staticClass:"modalContent"},[(_vm.loading)?_c('div',{staticClass:"loading"}):_vm._e()])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }